export const checkLocalStorage = (key: string) => {
    const value = typeof window !== 'undefined' && localStorage.getItem(key)

    return value ? JSON.parse(value) : undefined
}
